import { render } from "./Property.vue?vue&type=template&id=3ed35952&scoped=true"
import script from "./Property.vue?vue&type=script&lang=js"
export * from "./Property.vue?vue&type=script&lang=js"

import "./Property.vue?vue&type=style&index=0&id=3ed35952&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ed35952"

export default script